module.exports = __webpack_public_path__ + "static/media/features-shiftManagement.09c867e9.png";